<button type="button" [ngClass]="styles.approvalSubmitBtn" [hidden]="!(templateListCount !== undefined)" [disabled]="isMoreThanOneTemplate && !isTemplateSelected" (click)="approvalSubmit()" [tooltip]="'UI_SubmitForApproval_Tooltip' | translate" [triggers]="'hover'" [placement]="'right'" vbBtnPrimary>
	<span [hidden]="isSubmitted">
		{{ (isMoreThanOneTemplate ? 'UI_Submit' : 'UI_SubmitForApproval') | translate }}
	</span>
	<span [hidden]="!isSubmitted">
		<vb-loading-spinner class="margin-right-5" [size]="'xsmall'" [customStylesClass]="styles.customSpinnerStyles"></vb-loading-spinner>
		{{ 'Processing' | translate }}
	</span>
</button>